export const MojiraBugtrackerBackendPaths = {
  siteInfo: 'site-info',
  userDetails: 'user-details',
  recordRating: 'record-rating',
  getRating: 'get-rating',
  listServiceDesks: 'list-service-desks',
  getServiceDesk: 'get-service-desk',
  listQueues: 'list-queues',
  listIssues: 'list-issues',
  jqlSearchGet: 'jql-search-get',
  jqlSearchPost: 'jql-search-post',
  basicSearchGet: 'basic-search-get',
  issueCommentGet: 'issue-comment-get',
  projectSearchGet: 'project-search-get',
  serviceDeskGet: 'service-desk-get',
  issueAttachmentGet: 'issue-attachment-get'
};
